"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultContext = void 0;
/**
 * Collects device and browser context information from the browser environment.
 * @returns An object containing device, browser, and page context information.
 */
var getDefaultContext = function () {
    var _a, _b, _c, _d, _e, _f;
    var context = {};
    if (window === null || window === void 0 ? void 0 : window.navigator) {
        var navigator_1 = window === null || window === void 0 ? void 0 : window.navigator;
        context = {
            userAgentData: {
                brands: (_b = (_a = navigator_1 === null || navigator_1 === void 0 ? void 0 : navigator_1.userAgentData) === null || _a === void 0 ? void 0 : _a.brands) === null || _b === void 0 ? void 0 : _b.map(function (brand) { return ({
                    brand: brand === null || brand === void 0 ? void 0 : brand.brand,
                    version: brand === null || brand === void 0 ? void 0 : brand.version,
                }); }),
                mobile: (_c = navigator_1 === null || navigator_1 === void 0 ? void 0 : navigator_1.userAgentData) === null || _c === void 0 ? void 0 : _c.mobile,
                platform: ((_d = navigator_1 === null || navigator_1 === void 0 ? void 0 : navigator_1.userAgentData) === null || _d === void 0 ? void 0 : _d.platform) || (navigator_1 === null || navigator_1 === void 0 ? void 0 : navigator_1.platform),
            },
            userAgent: navigator_1 === null || navigator_1 === void 0 ? void 0 : navigator_1.userAgent,
            locale: navigator_1 === null || navigator_1 === void 0 ? void 0 : navigator_1.language,
        };
    }
    if (window === null || window === void 0 ? void 0 : window.location) {
        var location_1 = window === null || window === void 0 ? void 0 : window.location;
        context.page = {
            path: location_1 === null || location_1 === void 0 ? void 0 : location_1.pathname,
            search: location_1 === null || location_1 === void 0 ? void 0 : location_1.search,
            title: document === null || document === void 0 ? void 0 : document.title,
            url: location_1 === null || location_1 === void 0 ? void 0 : location_1.href,
            referrer: document === null || document === void 0 ? void 0 : document.referrer,
        };
    }
    context.timezone = (_f = (_e = Intl === null || Intl === void 0 ? void 0 : Intl.DateTimeFormat()) === null || _e === void 0 ? void 0 : _e.resolvedOptions()) === null || _f === void 0 ? void 0 : _f.timeZone;
    return context;
};
exports.getDefaultContext = getDefaultContext;
